import { StringParam, withDefault } from 'use-query-params';
import { SchemaFilterType, SortDir } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'orderCreatedAt',
    label: 'Date',
    hidden: false,
  },
  {
    name: 'status',
    label: 'Status',
    sortable: false,
  },
  {
    name: 'uploadedByEmployeeId',
    label: 'Uploaded',
    sortable: false,
  },
  {
    name: 'pspPartnerId',
    label: 'Partner Bank',
    sortable: false,
  },
  {
    name: 'pspPartnerAccountId',
    label: 'Partner Bank Account',
    sortable: false,
  },
  {
    name: 'allTransactions',
    label: 'Number of transactions',
    sortable: false,
  },
  {
    name: 'procTransactions',
    label: 'Not processed',
    sortable: false,
  },
  {
    name: 'acceptedTransactions',
    label: 'Processed successfully',
    sortable: false,
  },
  {
    name: 'rejectedTransactions',
    label: 'Error processed',
    sortable: false,
  },
];

export const columnsLabels = {};

export const defaultSorter = {
  sortProp: columns[1].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [];
